import { commonEnv } from 'src/environments/environment.common';
import { Environment } from '../types';

const env: Partial<Environment> = {
    production: false,
    environment: 'develop',
    googleMapApiKey: 'AIzaSyAP_jjx9h_j10H8uvMaknaXiRELzSlKs0o',
    addressValidationApiKey: 'AIzaSyBw-UUnq4Tga9oKRNMeu8MhvOZQIHHJn8w',
    projects: {
        sprintPay: 'https://qa.sprintpay.cargosprint.com',
    },
    authenticationURL: 'https://auth-develop.cargosprintgroup.com',
    appSentryDsn: 'https://cb7b91ba8292063fb1bb2ee018bb4cff@o4507337391734784.ingest.us.sentry.io/4507337393831936',
    statsigSdkKey: 'client-TMqqFjGeGc0kG9eRXJ6v4lOagxLOSuBdNvCfH6RjsO1',
    kioskFirebaseFunctions: 'https://us-central1-testkiosk-ed7b2.cloudfunctions.net',
    keycloakConfig: {
        url: 'https://sso-qa.cargosprint.com',
        realm: 'unified-portal-new',
        clientId: 'test-ui',
    },
    applicationName: 'alliance',
};

export const environment = Object.assign(commonEnv, env);
